import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import QueryClauseAddRows from '../components/QueryClauseAddRows';
import { canEditCohort } from '../../helper';
import QueryClausesTableRows from '../components/QueryClausesTableRows';
import ClausesProfileRows from '../../profile/components/ClausesProfileRows';
import { findQueryProfile } from '../../state/shared';

const QueryClausesTable = ({
  code,
  category,
  canEdit,
  isEditing,
  clauses,
  queryUUID,
  dictionaryCode,
  validationErrors,
  showCounts,
  saveErrors,
}) => {
  const newClause = clauses.find((c) => c.isNew);

  return (
    <Table
      unstackable
      compact
      className="aridhia-table-wrapper aridhia-query-filters-table"
    >
      <Table.Body>
        {showCounts && (
        <ClausesProfileRows
          dictionaryCode={dictionaryCode}
          code={code}
          category={category}
          canEdit={canEdit}
          isEditing={isEditing}
          queryUUID={queryUUID}
        />
        )}
        <QueryClausesTableRows
          clause={newClause}
          code={code}
          category={category}
          queryUUID={queryUUID}
          canEdit={canEdit}
          isEditing={isEditing}
          clauses={clauses}
          validationErrors={validationErrors}
        />
        {canEdit && isEditing && newClause && (
        <QueryClauseAddRows
          clause={newClause}
          firstClause={clauses.length === 1}
          code={code}
          category={category}
          queryUUID={queryUUID}
          saveErrors={saveErrors}
        />
        )}
      </Table.Body>
    </Table>
  );
};

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
  auth: {
    role,
  },
}, ownProps) => {
  const { cohort, clauses, profile } = findQueryProfile(cohorts, ownProps);

  return {
    clauses,
    canEdit: canEditCohort(cohort, role),
    isEditing: cohort.isEditing,
    saveErrors: cohort.saveErrors,
    showCounts: profile.showCounts,
  };
};

export default connect(mapStateToProps)(QueryClausesTable);
